export default __webpack_public_path__ + "84f895dcd5a0834d5526058be417850f.png";